import React, { useState } from "react";
import List from "share/atoms/ListView";
import NavItem from "./nav-item";
import { useHistory } from "react-router-dom";
import { neatRoutes } from "./routes";
import { ListWrap, Overlay } from "./styles";
import { FiMenu } from "react-icons/fi";
import Logo from "assets/ntat/icons/logo.svg";
import LogoutIcon from "assets/ntat/icons/logout.svg";
import NarayanaLogo from "assets/ntat/icons/narayana-logo.svg";
import { IoMdClose } from "react-icons/io";

export default function SidePanel({
  showSidebar = false,
  handleClose = () => {},
  handleLogout = () => {},
  children,
}) {
  const history = useHistory();
  const [isExpanded, setIsExpanded] = useState(showSidebar);
  const loginType = localStorage.getItem("login-type");

  const navigateToHome = () => {
    history.push("/");
  };

  const handleSidebarToggle = () => {
    if (handleClose) {
      handleClose();
    }
    setIsExpanded(!isExpanded);
  };
  return (
    <React.Fragment>
      <Overlay isExpanded={isExpanded} />
      <ListWrap
        className={isExpanded && `side-panel-expanded`}
        loginType={loginType}
      >
        <div
          className="hamburger-menu"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <FiMenu color="#3D6AE7" />
        </div>
        <div className="logo-wrap">
          <img onClick={navigateToHome} src={Logo} alt="neap logo" />
          <div className="close-icon" onClick={handleSidebarToggle}>
            <IoMdClose size={24} color="#000000" />
          </div>
        </div>
        {children}
        <List items={neatRoutes}>
          {(item) => <NavItem key={item.path} route={item} />}
        </List>

        <div className="logout-wrapper" onClick={handleLogout}>
          <img src={LogoutIcon} alt="logout-icon" />
          Logout
        </div>
        <img
          src={NarayanaLogo}
          alt="narayana group logo"
          className="narayana-logo"
        />
      </ListWrap>
    </React.Fragment>
  );
}
